export const MIN_PASSWORD_LENGTH = 8;

const HAS_UPPER = /[A-Z]/;
const HAS_LOWER = /[a-z]/;
const HAS_DIGIT = /[0-9]/;
const HAS_SPECIAL = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/;

export function validatePassword(password, confirmPassword) {
  const pwd = String(password ?? '');

  if (!pwd.trim()) {
    return { valid: false, message: 'Mật khẩu không được để trống' };
  }
  if (pwd.length < MIN_PASSWORD_LENGTH) {
    return { valid: false, message: `Mật khẩu phải có ít nhất ${MIN_PASSWORD_LENGTH} ký tự` };
  }
  if (!HAS_UPPER.test(pwd)) {
    return { valid: false, message: 'Mật khẩu phải có ít nhất một chữ hoa (A-Z)' };
  }
  if (!HAS_LOWER.test(pwd)) {
    return { valid: false, message: 'Mật khẩu phải có ít nhất một chữ thường (a-z)' };
  }
  if (!HAS_DIGIT.test(pwd)) {
    return { valid: false, message: 'Mật khẩu phải có ít nhất một chữ số (0-9)' };
  }
  if (!HAS_SPECIAL.test(pwd)) {
    return { valid: false, message: 'Mật khẩu phải có ít nhất một ký tự đặc biệt (@ # $ % ! ...)' };
  }
  if (confirmPassword !== undefined && pwd !== String(confirmPassword ?? '')) {
    return { valid: false, message: 'Mật khẩu nhập lại không khớp' };
  }

  return { valid: true, message: '' };
}

export function getPasswordRules() {
  return [
    `Ít nhất ${MIN_PASSWORD_LENGTH} ký tự`,
    'Có chữ hoa (A-Z)',
    'Có chữ thường (a-z)',
    'Có chữ số (0-9)',
    'Có ký tự đặc biệt (@ # $ % ! ...)',
    'Mật khẩu nhập lại phải trùng khớp',
  ];
}

export function checkPasswordRules(password) {
  const pwd = String(password ?? '');
  return {
    minLength: pwd.length >= MIN_PASSWORD_LENGTH,
    upper: HAS_UPPER.test(pwd),
    lower: HAS_LOWER.test(pwd),
    digit: HAS_DIGIT.test(pwd),
    special: HAS_SPECIAL.test(pwd),
  };
}
